import React from "react";

import { NOTES_CONFIG } from "./config";
import { Box } from "@mui/material";

import TextsmsIcon from "@mui/icons-material/Textsms";
import DescriptionIcon from "@mui/icons-material/Description";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import LinkIcon from '@mui/icons-material/Link';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import RegularButton from "components/CustomButtons/Button";
import { blue } from "@mui/material/colors";
import { PERMISSIONS } from "router/permissions";

export const columns = [
  {
    Header: () => <span>{NOTES_CONFIG.customer.label}</span>,
    accessor: NOTES_CONFIG.customer.key,
    filterable: true,
    filterMethod: () => true
  },
  {
    Header: () => <span>{NOTES_CONFIG.facility.label}</span>,
    accessor: NOTES_CONFIG.facility.key,
    filterable: true,
    filterMethod: () => true
  },
  {
    Header: () => <span>{NOTES_CONFIG.apartment.label}</span>,
    accessor: NOTES_CONFIG.apartment.key,
    filterable: true,
    filterMethod: () => true
  },
  {
    Header: () => <span>{NOTES_CONFIG.meter.label}</span>,
    accessor: NOTES_CONFIG.meter.key,
    filterable: true,
    filterMethod: () => true
  },
  {
    Header: () => <span>{NOTES_CONFIG.contract.label}</span>,
    accessor: NOTES_CONFIG.contract.key,
    filterable: true,
    filterMethod: () => true
  },
  {
    Header: () => <span>{NOTES_CONFIG.period.label}</span>,
    accessor: NOTES_CONFIG.period.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.period.key]
        ? row[NOTES_CONFIG.period.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.quantityM3.label}</span>,
    accessor: NOTES_CONFIG.quantityM3.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.quantityM3.key]
        ? row[NOTES_CONFIG.quantityM3.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.quantityLts.label}</span>,
    accessor: NOTES_CONFIG.quantityLts.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.quantityLts.key]
        ? row[NOTES_CONFIG.quantityLts.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.price.label}</span>,
    accessor: NOTES_CONFIG.price.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.price.key]
        ? row[NOTES_CONFIG.price.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.charge.label}</span>,
    accessor: NOTES_CONFIG.charge.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.charge.key]
        ? row[NOTES_CONFIG.charge.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.owed.label}</span>,
    accessor: NOTES_CONFIG.owed.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.owed.key]
        ? row[NOTES_CONFIG.owed.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.total.label}</span>,
    accessor: NOTES_CONFIG.total.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.total.key]
        ? row[NOTES_CONFIG.total.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{NOTES_CONFIG.paymentStatus.label}</span>,
    accessor: NOTES_CONFIG.paymentStatus.key,
    filterable: false,
    filterMethod: (filter, row) =>
      row[NOTES_CONFIG.paymentStatus.key]
        ? row[NOTES_CONFIG.paymentStatus.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const openFileModal = () => {
        original.file(original.id);
      };
      const openConfirmationModal = () => {
        original.confirmation(original.id);
      };
      const openPaymentLinkModal = () => {
        original.paymentUrl(original.paymentLink?.payment_url);
      };
      const openPaymentModal = () => {
        original.payment(original.id, { reference: original.payment_reference, id_charge: original.paymentLink?.id_charge }, original);
      };
      const openReassigntModal = () => {
        original.reassign(original.id,  { reference: original.payment_reference, id_charge: original.paymentLink?.id_charge }, original)
      }

      let btnLength = 2
      if (original.paymentLink?.payment_url) {
        btnLength += 1
      }
      if (original.rules.includes(PERMISSIONS.APPLY_PAYMENT) && original.payStatus === "PENDIENTE") {
        btnLength += 1
      } else if (original.rules.includes(PERMISSIONS.REASSIGN_PAYMENT) && original.payStatus === "PAGADO") {
        btnLength += 1
      }
      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: `${btnLength > 3 ? 'wrap' : 'default'}`,
            gap: "4"
          }}
        >
          <RegularButton
            tooltip="Enviar Mensaje"
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openConfirmationModal}
          >
            <TextsmsIcon style={{ color: blue[500] }} />
          </RegularButton>
          {original.paymentLink?.payment_url ?
            <RegularButton
              tooltip="Ver liga de pago"
              round
              justIcon
              color="transparent"
              size="sm"
              onClick={openPaymentLinkModal}
            >
              <LinkIcon style={{ color: blue[500] }} />
            </RegularButton>
            : null}
          <RegularButton
            tooltip="Ver Archivo"
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openFileModal}
          >
            <DescriptionIcon style={{ color: blue[500] }} />
          </RegularButton>
          {original.rules.includes(PERMISSIONS.APPLY_PAYMENT) && original.payStatus === "PENDIENTE" ?
            <RegularButton
              tooltip="Aplicar pago"
              round
              justIcon
              color="transparent"
              size="sm"
              onClick={openPaymentModal}
            >
              <CreditScoreIcon style={{ color: blue[500] }} />
            </RegularButton>
            : null}
          {original.rules.includes(PERMISSIONS.REASSIGN_PAYMENT) && original.payStatus === "PAGADO" ?
            <RegularButton
              tooltip="Reasignar pago"
              round
              justIcon
              color="transparent"
              size="sm"
              onClick={openReassigntModal}
            >
              <MoneyOffIcon style={{ color: blue[500] }} />
            </RegularButton>
            : null}
        </Box>
      );
    }
  }
];
